import { Component, inject } from '@angular/core';
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { MatCardModule } from '@angular/material/card';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { LowercaseDirective } from '../directives/lowercase.directive';
import { AutotrimDirective } from '../directives/autotrim.directive';
import { FormActionsComponent } from '../form-actions.component';
import { TranslateModule } from '@ngx-translate/core';
import { TranslationService } from '../service/translation-service.service';

@Component({
  selector: 'app-get-started',
  templateUrl: 'get-started.component.html',
  styleUrls: ['login-reset-register.component.scss'],
  imports: [
    ReactiveFormsModule,
    MatCardModule,
    MatInputModule,
    MatIconModule,
    MatButtonModule,
    LowercaseDirective,
    RouterModule,
    AutotrimDirective,
    FormActionsComponent,
    TranslateModule,
  ],
})
export class GetStartedComponent {
  private readonly translation = inject(TranslationService);

  videoForm = new FormBuilder().nonNullable.group({
    email: ['', [Validators.required, Validators.email]],
    name: ['', Validators.required],
    company: ['', Validators.required],
  });

  schedulaCall() {
    const { name, company, email } = this.videoForm.getRawValue();
    const params = new URLSearchParams({ name, company, email });
    window.location.href = `${this.translation.productDemoUrl()}?${params}`;
  }
}
